var Cart, DealEventPipe, InlineVariations, getBuyUrlWithShippingOptionData;

Cart = window.Cart != null ? window.Cart : window.Cart = {};

InlineVariations = window.InlineVariations != null ? window.InlineVariations : window.InlineVariations = {};

if (InlineVariations.Views == null) {
  InlineVariations.Views = {};
}

DealEventPipe = require('../../../deal/frontend/event_pipe');

Cart.Helpers = require('../../../cart/common/helpers');

getBuyUrlWithShippingOptionData = require('../../../goods_local_supply_v2/common/helpers').getBuyUrlWithShippingOptionData;

InlineVariations.Views.Main = Backbone.View.extend({
  el: '#inline-variations-container',
  body: 'body',
  inlineVariationsTraits: '.inline-variation-trait',
  inlineVariationsDropdowns: '.inline-variation-layout-generic-dropdown, .inline-variation-native-dropdown',
  touch: {
    main: '.t-main',
    featuredImg: '#featured-image',
    imageCarousel: '#image-wrapper ul li',
    featuredImgSize: 't300x182.jpg',
    buyButton: '#buy',
    priceBuy: '#price-buy',
    values: '#price-buy .value, #price-buy .breakout-option-value',
    prices: '#price-buy .price, #price-buy .breakout-option-price',
    filterSheetPrice: '#inline-variations-filters-header .price',
    urgencyPrice: '#price-buy .urgency-pricing-value-unit strong, #price-buy .breakout-option-price.urgency-pricing',
    urgencyOfferLabel: '#price-buy .urgency-pricing-value-unit .urgency-pricing-offer-label, #price-buy .urgency-pricing-label',
    deliveryEstimate: '.delivery-estimates-container',
    discount: '#discount-percent span, .discount-percentage',
    savings: '#discount-savings span',
    filters: '#inline-variations-filters',
    filtersHeight: '48%'
  },
  initialize: function() {
    if (this.$el == null) {
      this.$el = $(this.el);
    }
    _.extend(this, this.options);
    this.$inlineVariationsDropdowns = this.$el.find(this.inlineVariationsDropdowns);
    this.$inlineVariationsTraits = this.$el.find(this.inlineVariationsTraits);
    this.$body = $(this.body);
    if (this.isTouch) {
      this.$body = $(this.touch.main);
      this.$touchFeaturedImg = $(this.touch.featuredImg);
      this.$imageCarousel = $(this.touch.imageCarousel);
      this.$touchBuyButton = $(this.touch.buyButton);
      this.$touchPriceBuy = $(this.touch.priceBuy);
      this.$touchPrices = $(this.touch.prices);
      this.$touchFilterSheetPrice = $(this.touch.filterSheetPrice);
      this.$touchValues = $(this.touch.values);
      this.$touchUrgencyPrice = $(this.touch.urgencyPrice);
      this.$touchUrgencyOfferLabel = $(this.touch.urgencyOfferLabel);
      this.$touchDeliveryEstimate = $(this.touch.deliveryEstimate);
      this.$touchDiscount = $(this.touch.discount);
      this.$touchSavings = $(this.touch.savings);
      this.$touchFilters = $(this.touch.filters);
      this.touchDefaultCarouselSelection = {
        index: 0
      };
      DealEventPipe.on('touchCarouselSwiped', (function(_this) {
        return function(data) {
          return _this.updateInlineVariationSelectionsForTouch(data);
        };
      })(this));
      DealEventPipe.on('touchLocalSupplyUpdate', (function(_this) {
        return function(data) {
          var buyButtonData;
          if (data.isLocalSupplyTrigger && data.buyUrl) {
            buyButtonData = _.extend({}, data, {
              buyUrl: _this.getLocalSupplyUrl({
                buyUrl: data.buyUrl
              })
            });
            return _this.updateTouchBuyButton(buyButtonData);
          }
        };
      })(this));
      this.touchOriginalFeaturedImg = this.$touchFeaturedImg.attr('src');
    }
    this.attachBackdropEventListener();
    return this.makeSelectionsViaPreselection();
  },
  attachBackdropEventListener: function() {
    return this.$body.click((function(_this) {
      return function(e) {
        if (!_this.$body.hasClass('inline-variation-backdrop')) {
          return;
        }
        if (_this.$body.hasClass('stop-propagation')) {
          return _this.$body.removeClass('stop-propagation');
        } else {
          _this.traits.closeDropdowns();
          if (_this.isTouch) {
            return _this.$touchFilters.animate({
              height: '0'
            }, 400, 'swing', function() {
              _this.$body.removeClass('inline-variation-backdrop');
              _this.$touchFilters.height('auto');
              return _this._scrollToTouchInlineVariation();
            });
          } else {
            return _this.$body.removeClass('inline-variation-backdrop');
          }
        }
      };
    })(this));
  },
  makeSelectionsViaPreselection: function() {
    var i, len, option, ref, ref1, selections, trait, value;
    if (!((ref = this.preSelectTraits) != null ? ref.length : void 0)) {
      return;
    }
    if (!(option = this.options.findWhere({
      uuid: this.dealOptionUuid
    }))) {
      return;
    }
    selections = {};
    ref1 = this.preSelectTraits;
    for (i = 0, len = ref1.length; i < len; i++) {
      trait = ref1[i];
      if (value = option.get(trait)) {
        selections[trait] = value;
      }
    }
    this.updateSelections(selections);
    return this.render();
  },
  render: function(updateCarouselOrFeaturedImage) {
    if (updateCarouselOrFeaturedImage == null) {
      updateCarouselOrFeaturedImage = true;
    }
    this.updateSoldout();
    this.updatePriceAndBuyButton();
    if (updateCarouselOrFeaturedImage) {
      this.updateCarouselOrFeaturedImage();
    }
    return this.hideErrorMessages();
  },
  updateSoldout: function() {
    var currentValue, filteredSelection, i, len, ref, results, trait, traitValue;
    if (this.traits.models.length < 2) {
      return;
    }
    ref = this.traits.models;
    results = [];
    for (i = 0, len = ref.length; i < len; i++) {
      trait = ref[i];
      filteredSelection = _.omit(this.traits.selectedTraitValues, trait.get('name'));
      results.push((function() {
        var j, len1, ref1, results1;
        ref1 = trait.get('values') || [];
        results1 = [];
        for (j = 0, len1 = ref1.length; j < len1; j++) {
          traitValue = ref1[j];
          if (traitValue.isPlaceholder) {
            continue;
          }
          currentValue = {};
          currentValue[traitValue.traitName] = traitValue.name;
          results1.push(trait.view.toggleSoldOut(traitValue, (this.options.where(_.extend(filteredSelection, currentValue)).length) === 0 || traitValue.isSoldOut));
        }
        return results1;
      }).call(this));
    }
    return results;
  },
  updatePriceAndBuyButton: function() {
    var cheapestOption, oldPrice, optionInfo, qualifiedOptions;
    qualifiedOptions = this.getQualifiedOptions();
    if (!qualifiedOptions.length) {
      return;
    }
    if (!(cheapestOption = _.min(qualifiedOptions, function(option) {
      return option.get('amount');
    }))) {
      return;
    }
    if (cheapestOption === 2e308) {
      return;
    }
    oldPrice = cheapestOption.get('oldPrice');
    optionInfo = {
      dealUuid: this.dealUuid,
      buyUrl: this.buyButtonUrl(cheapestOption),
      hideOriginalPriceAndDiscount: cheapestOption.get('hideOriginalPriceAndDiscount') || (oldPrice === '$0'),
      id: cheapestOption.get('id'),
      lengthClass: cheapestOption.get('lengthClass'),
      percent: cheapestOption.get('discount'),
      price: cheapestOption.get('newPrice'),
      savings: cheapestOption.get('savePrice'),
      uuid: cheapestOption.get('uuid'),
      value: oldPrice,
      variationsSelected: qualifiedOptions.length === 1 && this.traits.allTraitValuesSelected()
    };
    this.overridePrice(optionInfo, cheapestOption);
    if (this.isTouch) {
      this.updateTouchDealInfo(optionInfo);
      this.updateTouchBuyButton(optionInfo);
      DealEventPipe.trigger("touchDeliveryEstimatesUpdate", optionInfo);
      return DealEventPipe.trigger("touchLocalSupplyUpdate", optionInfo);
    } else {
      DealEventPipe.trigger("priceUpdate", optionInfo);
      if (payload.goodsWarranty) {
        DealEventPipe.trigger("goodsWarrantyUpdate", optionInfo);
      }
      if (payload.buyMore) {
        return DealEventPipe.trigger("buyMoreUpdate", optionInfo, !optionInfo.variationsSelected);
      }
    }
  },
  updateTouchDealInfo: function(arg) {
    var hideOriginalPriceAndDiscount, id, percent, price, ref, sale, savings, urgencyPricing, uuid, value;
    hideOriginalPriceAndDiscount = arg.hideOriginalPriceAndDiscount, id = arg.id, percent = arg.percent, price = arg.price, sale = arg.sale, savings = arg.savings, uuid = arg.uuid, value = arg.value;
    this.$touchValues.text(hideOriginalPriceAndDiscount ? '' : value);
    this.$touchDiscount.html(percent);
    this.$touchSavings.text(savings);
    this.$touchPriceBuy.attr('data-option-id', id);
    if (urgencyPricing = sale != null ? sale.urgencyPricing : void 0) {
      this.$touchPrices.text(urgencyPricing.regularPrice);
      this.$touchFilterSheetPrice.text(urgencyPricing.newPrice);
      this.$touchUrgencyPrice.show().text(urgencyPricing.newPrice);
      this.$touchPriceBuy.addClass('urgency-pricing-cluster');
      if ((ref = urgencyPricing.pricingMetadata) != null ? ref.offerLabel : void 0) {
        return this.$touchUrgencyOfferLabel.show().text(urgencyPricing.pricingMetadata.offerLabel);
      } else {
        return this.$touchUrgencyOfferLabel.hide();
      }
    } else {
      this.$touchPrices.text(price);
      this.$touchFilterSheetPrice.text(price);
      return this.$touchPriceBuy.removeClass('urgency-pricing-cluster');
    }
  },
  updateTouchBuyButton: function(arg) {
    var buyUrl, id, variationsSelected;
    buyUrl = arg.buyUrl, id = arg.id, variationsSelected = arg.variationsSelected;
    if (variationsSelected) {
      this.$touchBuyButton.attr('href', buyUrl);
      if (this.isCart) {
        return this.$touchBuyButton.attr('data-option', id);
      }
    } else {
      this.$touchBuyButton.removeAttr('href');
      if (this.isCart) {
        return this.$touchBuyButton.removeAttr('data-option');
      }
    }
  },
  getQualifiedOptions: function() {
    if (this.traits.someTraitValuesSelected()) {
      return this.options.where(this.traits.selectedTraitValues);
    } else {
      return this.options.models;
    }
  },
  variationsSelected: function() {
    var qualifiedOptions;
    qualifiedOptions = this.getQualifiedOptions();
    return qualifiedOptions.length === 1 && this.traits.allTraitValuesSelected();
  },
  buyButtonUrl: function(option) {
    var ref;
    switch (false) {
      case !((ref = option.get('externalUrl')) != null ? ref.length : void 0):
        return option.get('externalUrl');
      case !(this.isCart && !payload.shouldDisableGoodsCart):
        return Cart.Helpers.generateCartUrl(option.get('uuid'), this.dealUuid);
      default:
        return option.get('url');
    }
  },
  overridePrice: function(optionInfo, option) {
    var offer, ref, ref1, ref2, ref3, sale;
    if (!((option.get('regularPrice') != null) || ((ref = this.offer) != null ? (ref1 = ref.offerOptions) != null ? ref1.length : void 0 : void 0))) {
      return;
    }
    sale = {};
    if (option.get('regularPrice')) {
      sale.urgencyPricing = {
        newPrice: option.get('newPrice'),
        pricingMetadata: option.get('pricingMetadata'),
        regularPrice: option.get('regularPrice')
      };
    }
    if (offer = _.findWhere((ref2 = this.offer) != null ? ref2.offerOptions : void 0, {
      id: option.get('uuid')
    })) {
      if (offer.buyUrl && !((ref3 = this.offer.offerModal) != null ? ref3.isSoldOut : void 0)) {
        optionInfo.buyUrl = offer.buyUrl;
      }
      _.extend(sale, {
        offer: offer
      });
    }
    if (sale !== {}) {
      return _.extend(optionInfo, {
        sale: sale
      });
    }
  },
  updateCarouselOrFeaturedImage: function() {
    var currentBaseUrl, image, imageUrl, valueHash;
    if (this.isTouch) {
      if (!this.$imageCarousel.length) {
        if (imageUrl = this.findFeaturedImageUrl()) {
          return this.$touchFeaturedImg.attr('src', imageUrl);
        }
      } else if (valueHash = this.findCarouselImageIndexForTouch()) {
        if (this.carouselImageIndex !== valueHash.index) {
          return this.swipeTouchCarousel(valueHash);
        }
      }
    } else if (image = this.findCarouselImage()) {
      currentBaseUrl = this.carouselViews[this.dealUuid].currentFeatured.baseURL;
      if (currentBaseUrl !== image.baseURL) {
        payload.firedByTraitSelection = true;
        return this.carouselViews[this.dealUuid].updateGallery(image);
      }
    }
  },
  swipeTouchCarousel: function(arg) {
    var index, ref;
    index = arg.index;
    DealData.firedByTraitSelection = true;
    this.carouselImageIndex = index;
    return (ref = window.TouchDeal) != null ? ref._swipe.slide(index) : void 0;
  },
  findFeaturedImageUrl: function() {
    var image, ref;
    if (!(image = (ref = this.options.findWhere(this.traits.selectedTraitValues)) != null ? ref.get('image') : void 0)) {
      return this.touchOriginalFeaturedImg;
    }
    return "" + image + this.touch.featuredImgSize;
  },
  findCarouselImage: function() {
    var foundMatch, imageUrl, ref, valuesHash;
    if (!this.traits.someTraitValuesSelected()) {
      return this.dealMedia[this.dealUuid].models[0];
    }
    ref = this.mappings;
    for (imageUrl in ref) {
      valuesHash = ref[imageUrl];
      foundMatch = _.every(this.traits.models, function(trait) {
        var selectedTraitValue;
        if (!(selectedTraitValue = trait.get('selectedTraitValue'))) {
          return true;
        }
        return _.contains(valuesHash[trait.get('name')], selectedTraitValue);
      });
      if (foundMatch) {
        this.carouselImage = imageUrl;
        return this.dealMedia[this.dealUuid].findWhere({
          baseURL: imageUrl
        });
      }
    }
  },
  findCarouselImageIndexForTouch: function() {
    var foundMatch, imageUrl, ref, valuesHash;
    if (!this.traits.someTraitValuesSelected()) {
      return this.touchDefaultCarouselSelection;
    }
    ref = this.mappings;
    for (imageUrl in ref) {
      valuesHash = ref[imageUrl];
      foundMatch = _.every(this.traits.models, function(trait) {
        var selectedTraitValue;
        if (!(selectedTraitValue = trait.get('selectedTraitValue'))) {
          return true;
        }
        return _.contains(valuesHash[trait.get('name')], selectedTraitValue);
      });
      if (foundMatch) {
        return valuesHash;
      }
    }
  },
  updateInlineVariationSelections: function(image) {
    var key, ref, selections, value;
    if (payload.firedByTraitSelection) {
      return payload.firedByTraitSelection = false;
    }
    if (!image) {
      return;
    }
    if (image === this.carouselImage) {
      return;
    }
    this.carouselImage = image;
    selections = {};
    if (this.mappings[image]) {
      ref = this.mappings[image];
      for (key in ref) {
        value = ref[key];
        if (value.length === 1) {
          selections[key] = value[0];
        }
      }
    }
    this.updateSelections(selections);
    return this.render(false);
  },
  updateInlineVariationSelectionsForTouch: function(arg) {
    var index, key, ref, selections, value;
    index = arg.index;
    if (DealData.firedByTraitSelection) {
      return DealData.firedByTraitSelection = false;
    }
    if (index === this.carouselImageIndex) {
      return;
    }
    this.carouselImageIndex = index;
    selections = {};
    ref = _.findWhere(this.mappings, {
      index: index
    });
    for (key in ref) {
      value = ref[key];
      if (value.length === 1) {
        selections[key] = value[0];
      }
    }
    this.updateSelections(selections);
    return this.render(false);
  },
  updateSelections: function(selections) {
    var i, len, ref, results, trait;
    ref = this.traits.models;
    results = [];
    for (i = 0, len = ref.length; i < len; i++) {
      trait = ref[i];
      results.push(trait.setSelectedTraitValueByName(selections[trait.get('name')]));
    }
    return results;
  },
  showErrorMessages: function() {
    var i, len, ref, results, trait;
    this.$el.addClass('error');
    ref = this.traits.models;
    results = [];
    for (i = 0, len = ref.length; i < len; i++) {
      trait = ref[i];
      results.push(trait.view.showErrorMessages());
    }
    return results;
  },
  hideErrorMessages: function() {
    var i, len, ref, results, trait;
    this.$el.removeClass('error');
    ref = this.traits.models;
    results = [];
    for (i = 0, len = ref.length; i < len; i++) {
      trait = ref[i];
      results.push(trait.view.hideErrorMessages());
    }
    return results;
  },
  showBackdrop: function(traitView) {
    var isOpen;
    isOpen = this.$body.hasClass('inline-variation-backdrop');
    this.$body.addClass('inline-variation-backdrop stop-propagation');
    if (!this.isTouch) {
      return;
    }
    if (isOpen) {
      return traitView.slideDownAnimation(isOpen);
    } else {
      return this.$touchFilters.animate({
        height: this.touch.filtersHeight
      }, function() {
        return traitView.slideDownAnimation(isOpen);
      });
    }
  },
  getLocalSupplyUrl: function(arg) {
    var buyUrl, ref, shippingOptionData;
    buyUrl = arg.buyUrl;
    if (!(shippingOptionData = typeof GoodsLocalSupply !== "undefined" && GoodsLocalSupply !== null ? (ref = GoodsLocalSupply.View) != null ? ref.getSelectedShippingOptionData() : void 0 : void 0)) {
      return;
    }
    return getBuyUrlWithShippingOptionData(buyUrl, shippingOptionData);
  }
});

module.exports = InlineVariations.Views.Main;

//# sourceMappingURL=data:application/json;base64,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
